import { useMemo } from 'react';
import EpcSchedulePanel, { type EpcScheduleRevisionDetail } from '../../schedule/EpcSchedulePanel';
import type { EpcScheduleTaskRow } from '../../types/scheduleTask';
import { useEpcProjectDetail } from '../EpcProjectDetailContext';

type ImportHistoryRow = {
  version?: number;
  source?: string;
  originalFileName?: string;
  status?: string;
  createdAt?: string;
};

export default function EpcProjectScheduleTab() {
  const { id, project, snapshot, importHistory, canUpdate, reload } = useEpcProjectDetail();
  const currentVersion = useMemo(() => {
    let max = 0;
    for (const row of importHistory) {
      const v = Number((row as { version?: unknown })?.version);
      if (Number.isFinite(v) && v > max) max = v;
    }
    return max;
  }, [importHistory]);
  /* Latest ready import — the revision the grid is currently showing. */
  const currentRevision = useMemo<EpcScheduleRevisionDetail | null>(() => {
    let best: ImportHistoryRow | null = null;
    for (const raw of importHistory) {
      const row = (raw && typeof raw === 'object' ? raw : {}) as ImportHistoryRow;
      if (row.status !== 'ready') continue;
      const v = Number(row.version);
      if (!Number.isFinite(v)) continue;
      if (!best || v > Number(best.version)) best = row;
    }
    if (!best) return null;
    return {
      version: Number(best.version),
      originalFileName: best.originalFileName,
      source: best.source,
      createdAt: best.createdAt,
    };
  }, [importHistory]);
  if (!project) return null;
  const tasks = (snapshot?.tasks as EpcScheduleTaskRow[] | undefined) || [];
  return (
    <EpcSchedulePanel
      projectId={id}
      tasks={tasks}
      onScheduleChanged={reload}
      fullSnapshot={snapshot}
      projectCode={project.code}
      canUpdate={canUpdate}
      currentVersion={currentVersion}
      currentRevision={currentRevision}
    />
  );
}
